<template>
  <div class="reset-pass-container">
    <RegLeftBar/>
    <div class="form-section">
      <form class="reset-pass-form" novalidate @submit.prevent="sendCode">
        <h1 class="title">Reset password</h1>
        <div class="form-input">
          <label for="new-password" class="password-label">New password</label>
          <input id="new-password" ref="passwordInput" v-model="password" type="password"
                 name="password" autocomplete="new-password" minlength="8"
                 :aria-invalid="Boolean(passwordError)" aria-describedby="password-hint password-error"
                 @input="passwordError = ''">
          <p id="password-hint" class="password-hint">Use at least 8 characters.</p>
          <p v-if="passwordError" id="password-error" class="reset-error" role="alert">{{ passwordError }}</p>
        </div>
        <button
            type="submit"
            class="primary"
            :disabled="submitting || invalidLink"
        >
          {{ submitting ? 'Updating…' : 'Continue' }}
        </button>
        <p v-if="errorMessage" class="reset-error" role="alert">{{ errorMessage }}</p>
        <router-link v-if="invalidLink" class="reset-link" :to="{name: 'forget-password'}">Request a new reset link</router-link>
      </form>
    </div>
  </div>
</template>

<script>
import preloader from "@/mixins/preloader";
import helper from "@/mixins/helper";

export default {
  name: 'ResetPassword',
  mixins: [helper, preloader],
  data() {
    return {
      email: null,
      token: null,
      password: null,
      submitting: false,
      passwordError: '',
      invalidLink: false,
      errorMessage: ''
    }
  },
  mounted() {
    this.email = this.$route.query.email
    this.token = this.$route.query.token

    if (!this.email || !this.token) {
      this.invalidLink = true;
      this.errorMessage = 'Open the reset link from your email, or request a new one.';
    }

    this.$router.replace({query: {}})
    this.setLoading(false)
  },
  methods: {
    async sendCode() {
      if (this.submitting) return;
      if (this.invalidLink) return;
      this.errorMessage = '';
      this.passwordError = '';
      this.password = this.$refs.passwordInput.value;
      if (!this.password || this.password.length < 8) {
        this.passwordError = 'Please enter at least 8 characters.';
        return;
      }
      this.submitting = true;
      try {
        await this.axios.get(`${process.env.VUE_APP_LIVE_URL}/sanctum/csrf-cookie`);
        const res = await this.axios.post('reset-password', {
        password: this.password,
        email: this.email,
        token: this.token
        });
        this.toast.info(res.data.message);
        this.password = null
        this.$router.push({name: 'login'})
      } catch (error) {
        this.invalidLink = error.response?.data?.code === 'INVALID_RESET_LINK';
        if (error.response?.data?.errors?.password) {
          this.passwordError = error.response.data.errors.password[0];
          return;
        }
        this.errorMessage = error.response?.data?.message || 'Unable to reset your password. Please try again.';
        this.toast.error(this.errorMessage);
      } finally {
        this.submitting = false;
      }
    }
  }
}
</script>

<style scoped>
.password-label { display: block; margin-bottom: 12px; }
.password-hint { margin-top: 8px; color: #66758c; font-size: 14px; line-height: 1.5; }
.reset-error { margin: 12px 0; color: #b42318; font-size: 14px; line-height: 1.5; }
.reset-link { display: inline-block; margin-top: 12px; color: #007cae; font-size: 14px; text-decoration: underline; }
button.primary { border: 0; padding: 14px 24px; border-radius: 10px; cursor: pointer; }
button.primary:disabled { opacity: 0.6; cursor: default; }
</style>

<script setup>
import './ResetPassword.scss'
import RegLeftBar from '@/router/components/RegLeftBar/RegLeftBar.vue';

</script>
